import {
    IconAlmond,
    IconBanana,
    IconFish,
    IconNuts,
    IconSesame,
    IconSoy,
    IconBeef,
    IconChocolate,
    IconCitrus,
    IconCorn,
    IconEgg,
    IconGluten,
    IconLactose,
    IconLamb,
    IconPeanut,
    IconPork,
    IconPoultry,
    IconMilk,
    IconShellfish,
    IconStrawberry,
    IconTomato,
    IconWheat,
    IconYeast,
    IconAyurvedic,
    IconBalancedDiet,
    IconCarnivore,
    IconFlexitarian,
    IconGlutenFree,
    IconHalal,
    IconHighProtein,
    IconKeto,
    IconKosher,
    IconLactoOvoVegetarian,
    IconLactoVegetarian,
    IconLactoseFree,
    IconLowCarb,
    IconLowFodmap,
    IconOvoVegetarian,
    IconPaleo,
    IconRawVegan,
    IconVegan,
    IconVegetarian,
} from '../components/buttons/IconButtons';

export const Allergens = {
    1: { icon: IconAlmond, name: 'almonds' },
    2: { icon: IconBanana, name: 'banana' },
    3: { icon: IconChocolate, name: 'chocolate' },
    4: { icon: IconCitrus, name: 'citrus' },
    5: { icon: IconCorn, name: 'corn' },
    6: { icon: IconEgg, name: 'egg' },
    7: { icon: IconFish, name: 'fish' },
    8: { icon: IconGluten, name: 'gluten' },
    9: { icon: IconLactose, name: 'lactose' },
    10: { icon: IconMilk, name: 'milk' },
    11: { icon: IconNuts, name: 'nuts' },
    12: { icon: IconPeanut, name: 'peanut' },
    13: { icon: IconSesame, name: 'sesame' },
    14: { icon: IconShellfish, name: 'shellfish' },
    15: { icon: IconSoy, name: 'soy' },
    16: { icon: IconStrawberry, name: 'strawberries' },
    17: { icon: IconTomato, name: 'tomato' },
    18: { icon: IconWheat, name: 'wheat' },
    19: { icon: IconYeast, name: 'yeast' },
    20: { icon: IconBeef, name: 'beef' },
    21: { icon: IconLamb, name: 'lamb' },
    22: { icon: IconPork, name: 'pork' },
    23: { icon: IconPoultry, name: 'poultry' },
};
export const Diets = {
    1: { icon: IconAyurvedic, name: 'ayurvedic' },
    2: { icon: IconBalancedDiet, name: 'balanced_diet' },
    3: { icon: IconCarnivore, name: 'carnivore' },
    4: { icon: IconFlexitarian, name: 'flexitarian' },
    5: { icon: IconGlutenFree, name: 'gluten_free' },
    6: { icon: IconHalal, name: 'halal' },
    7: { icon: IconHighProtein, name: 'high_protein' },
    8: { icon: IconKeto, name: 'keto' },
    9: { icon: IconKosher, name: 'kosher' },
    10: { icon: IconLactoOvoVegetarian, name: 'lacto_ovo_vegetarian' },
    11: { icon: IconLactoVegetarian, name: 'lacto_vegetarian' },
    12: { icon: IconLactoseFree, name: 'lactose_free_dairy_free' },
    13: { icon: IconLowCarb, name: 'low_carb' },
    14: { icon: IconLowFodmap, name: 'low_fodmap' },
    15: { icon: IconOvoVegetarian, name: 'ovo_vegetarian' },
    16: { icon: IconPaleo, name: 'paleo' },
    17: { icon: IconRawVegan, name: 'raw_vegan' },
    18: { icon: IconVegan, name: 'vegan' },
    19: { icon: IconVegetarian, name: 'vegetarian' },
};
